import styled from 'styled-components';

export const SpacerElement = styled.div`
  background-color: transparent;
  padding: 7.5px 0 7.5px 0;
  width: 100%;
`;

export const HorizontalRuler = styled.div`
  border-bottom: 1px solid rgba(38, 50, 56, 0.12);
`;
